import { useMemo } from 'react';
import useEmployees from './useEmployees';
import {
    getEmployeesWithEmploymentInfo,
    type EmployeesWithEmploymentInfo,
} from 'src/lib/utils';

const useEmployeesWithEmploymentInfo = (): {
    employeesWithEmploymentInfo: EmployeesWithEmploymentInfo | undefined;
    isLoadingEmployees: boolean;
} => {
    const { employees, isLoadingEmployees } = useEmployees();

    const employeesWithEmploymentInfo: EmployeesWithEmploymentInfo | undefined =
        useMemo(
            () =>
                employees
                    ? getEmployeesWithEmploymentInfo(employees)
                    : undefined,
            [employees],
        );

    return {
        employeesWithEmploymentInfo,
        isLoadingEmployees,
    };
};

export default useEmployeesWithEmploymentInfo;
